import { render, staticRenderFns } from "./AccessoryOrders.vue?vue&type=template&id=232c71c7&"
import script from "./AccessoryOrders.vue?vue&type=script&lang=js&"
export * from "./AccessoryOrders.vue?vue&type=script&lang=js&"
import style0 from "./AccessoryOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports